import Guide from '@/components/guide/index'
import Share from '@/components/share/index'
import Community from '@/components/community/index'
import Shop from '@/components/shop/index'

const routes = [
  {
    path: '/guide/:language/:identity',
    name: 'GuideIndex',
    component: Guide
  }, {
    path: '/share/:identity',
    name: 'ShareIndex',
    component: Share
  }, {
    path: '/community/:type',
    name: 'CommunityIndex',
    component: Community
  }, {
    path: '/shop/:type',
    name: 'ShopIndex',
    component: Shop
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js